import React from "react";

// /document-api?i=response
export default function Response() {
  return (
    <>
              <table className="table table-striped-columns table-hover mb-3">
                <thead>
                  <tr>
                    <td className="wpx-130">Response Code</td>
                    <td className="wpx-100">Code</td>
                    <td className="wpx-170">Message</td>
                    <td>Response</td>
                  </tr>
                </thead>
                <tbody>
                  {global.response.map((item) => (
                    <tr key={item.code}>
                      <td data-label="Response Code">{item.response_code}</td>
                      <td data-label="Code">{item.code}</td>
                      <td data-label="Message">"{item.message}"</td>
                      <td data-label="Response">
                        <pre>{item.format_return}</pre>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
    </>
  );
}
